import React, { useEffect, useState, ReactNode } from "react"
import { Link } from "gatsby"
// @ts-ignore
import ConditionButton from "./condition-button"
// @ts-ignore
import Button from "./button"
import RandomImage from "../tsx-components/random-image"

import HeroImageGateway from "../../images/ayvakit-logo-hero-gateway.png"
import HeroImageAdvSm from "../../images/ayvakit-logo-hero-advsm.png"
import HeroImageGist from "../../images/ayvakit-logo-hero-gist.png"

import ismBgMobile1 from "../../images/ism-home-mobile1.png"
import ismBgMobile2 from "../../images/ism-home-mobile2.png"
import ismBgMobile3 from "../../images/ism-home-mobile3.png"
import ismBgDesktop1 from "../../images/ism-home-desktop1.png"
import ismBgDesktop2 from "../../images/ism-home-desktop2.png"
import ismBgDesktop3 from "../../images/ism-home-desktop3.png"

import iconSymptomReduction from "../../images/icon-hero-ism-1.png"
import iconLearnHow from "../../images/icon-hero-ism-2.png"
import iconPatientProfiles from "../../images/icon-hero-ism-3.png"

import iconArrow from "../../images/icon-hero-ism-arrow.svg"
import {
  faAngleDown,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"

const GlobalHero = ({
  type,
  headline,
  subhead,
  title,
  hidesidebar = false,
}: {
  type: string
  headline: ReactNode
  subhead: ReactNode
  title: string
  hidesidebar?: boolean
}) => {

  const desktopImages = [ismBgDesktop1, ismBgDesktop2, ismBgDesktop3];
  const mobileImages = [ismBgMobile1, ismBgMobile2, ismBgMobile3];

  const placeHeroBlock = (t: string) => {
    switch (t) {
      case "gateway":
        return (
          <div className="row collapse">
            <div className="columns collapse small-6 medium-4 large-4 xlarge-3">
              <img src={HeroImageGateway} alt="AYVAKIT® logo" />
            </div>
            <div className="columns collapse small-12 medium-5 large-5 align-self-middle">
              <div className="hero-copy-container">
                <h1>{headline}</h1>
              </div>
            </div>
          </div>
        )
      case "ism-home":
        return (
          <div className="hero">
            <RandomImage 
              desktopImageSet={desktopImages} 
              mobileImageSet={mobileImages}
            />
            <h1>For adults with indolent systemic mastocytosis</h1>
            <div className="hero-buttons">
              <span className="patient-portrayal">Patient portrayal</span>
              <a href="/ism/efficacy/" className="button explore-overall">
                <img src={iconSymptomReduction} alt="Scatter chart" role="presentation" />
                <p>
                  EXPLORE&nbsp;OVERALL <br />
                  <span>SYMPTOM&nbsp;IMPACT</span>
                </p>
                <img src={iconArrow} alt="" />
              </a>
              <a href="/ism/safety/" className="button">
                <img src={iconLearnHow} alt="Clipboard" role="presentation" />
                <p>
                  LEARN HOW AYVAKIT WAS <span>TOLERATED AT 25 MG</span> ONCE
                  DAILY
                </p>
                <img src={iconArrow} alt="" />
              </a>
              <a href="/ism/patient-perspectives/profiles/" className="button">
                <img src={iconPatientProfiles} alt="Patient profiles" role="presentation" />
                <p>
                  VIEW ISM EXAMPLE <span>PATIENT&nbsp;PROFILES</span>
                </p>
                <img src={iconArrow} alt="" />
              </a>
            </div>
            <div className="hero-callout">
              <h2>
                AYVAKIT is the ONLY FDA-approved therapy for ISM. AYVAKIT
                targets KIT D816V, the&nbsp;underlying driver of disease in ~95%
                of patients
                <sup>1-4</sup>
              </h2>
            </div>
          </div>
        )
      case "ism":
        return (
          <div className="row ism-hero" title={title}>
            <div className="block-hero-wrapper">
              <h1>{headline}</h1>
              <p className="subhead">{subhead}</p>
            </div>
          </div>
        )
      case "advsm":
        return (
          <div className="row collapse">
            <div className="columns collapse medium-4 small-9">
              <img src={HeroImageAdvSm} alt="AYVAKIT® logo" />
            </div>
            <div className="columns collapse small-12 medium-6 large-7 align-self-middle pt-1">
              <div className="hero-copy-container">
                <h1>{headline}</h1>
                <h2 className="font-din-pro-regular gw-h2-subheader font-weight-normal">
                  {subhead}
                </h2>
              </div>
            </div>
          </div>
        )
      case "gist":
        return (
          <div className="row collapse">
            <div className="columns collapse small-9 medium-5">
              <img src={HeroImageGist} alt="Ayvakit Hero Logo GIST" />
            </div>
            <div className="columns collapse small-12 medium-6 large-6 align-self-middle pt-1 md_pt-8 gist-hero-content">
              <div className="row collapse">
                <div className="columns collapse small-1 medium-1 large-1 headline-accent"></div>
                <div className="columns collapse hero-copy-container">
                  <h1>{headline}</h1>
                  <h2 className="font-din-pro-regular gw-h2-subheader font-weight-normal">
                    {subhead}
                  </h2>
                  <Button
                    copy="Contact Us"
                    url="/gist-hcp/#contact-us"
                    buttontheme="yellow-sky-blue-navy"
                    texttransform="uppercase"
                    className={undefined}
                    iconurl={undefined}
                    alt={undefined}
                    onclick={undefined}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      default:
        return <h1>NO TYPE DEFINED</h1>
    }
  }

  const placeSubNav = (t: string) => {
    switch (t) {
      case "ism":
        return (
          <div className="hero-menu-desktop ism" role="menubar">
            <div className="submenu-item text-center">
              <Link
                to="/ism/impact-of-ism/about-ism"
                className="sm-link-header impact-nav-item"
                activeClassName="active"
                aria-haspopup="true"
                aria-expanded="false"
                role="menuitem"
                tabIndex={0}
                partiallyActive
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.impact-nav-item');
                    const subMenuItem = document.querySelector('.impact-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Impact of ISM&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link to="/ism/impact-of-ism/about-ism" role="menuitem" tabIndex={0}>About ISM</Link>
                <Link to="/ism/impact-of-ism/burden-ism" role="menuitem" tabIndex={0}>Burden of ISM</Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/about-ayvakit/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                role="menuitem"
                tabIndex={0}
              >
                &nbsp;&nbsp;About AYVAKIT&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/efficacy/pioneer-study-design"
                className="sm-link-header efficacy-nav-item ligatures-off"
                activeClassName="active"
                role="menuitem"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                partiallyActive
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.efficacy-nav-item');
                    const subMenuItem = document.querySelector('.efficacy-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Efficacy&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link to="/ism/efficacy/pioneer-study-design" role="menuitem" tabIndex={0}>
                  PIONEER Study Design
                </Link>
                <Link 
                  to="/ism/efficacy"
                  className="ligatures-off"
                  role="menuitem"
                  tabIndex={0}
                >
                    Efficacy
                </Link>
              </div>
            </div>
            <br className="submenu-br" />
            <div className="submenu-item text-center">
              <Link
                to="/ism/safety/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                tabIndex={0}
                role="menuitem"
              >
                &nbsp;&nbsp;Safety&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center" role="menu" hidden>
              <Link
                to="/ism/dosing/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                tabIndex={0}
                role="menuitem"
              >
                &nbsp;&nbsp;Dosing&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/patient-perspectives/stories"
                className="sm-link-header patient-profiles-nav-item"
                activeClassName="active"
                role="menuitem"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                partiallyActive
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.patient-profiles-nav-item');
                    const subMenuItem = document.querySelector('.patient-profiles-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Patient Perspectives&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link to="/ism/patient-perspectives/stories" role="menuitem" tabIndex={0}>
                  Patient Stories
                </Link>
                <Link to="/ism/patient-perspectives/profiles" role="menuitem" tabIndex={0}>
                  Patient Profiles
                </Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/resources/access-support"
                className="sm-link-header resources-nav-item"
                activeClassName="active"
                role="menuitem"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.resources-nav-item');
                    const subMenuItem = document.querySelector('.resources-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Resources&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link
                  to="/ism/resources/access-support"
                  activeClassName="active"
                  partiallyActive
                  role="menuitem"
                  tabIndex={0}
                >
                  Access and Support
                </Link>
                <Link
                  to="/ism/resources/practice-resources"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Practice Resources
                </Link>
                <Link
                  to="/ism/resources/patient-resources"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Patient Resources
                </Link>
                <Link to="/ism/resources/faqs" activeClassName="active" role="menuitem" tabIndex={0}>
                  FAQs
                </Link>
                <Link to="/ism/connect-with-us" activeClassName="active" role="menuitem" tabIndex={0}>
                  Connect with Us
                </Link>
                <a
                  href="https://www.smdirectory.com/"
                  target="_blank"
                  className="sm-peer-directory-nav-item"
                  rel="noopener"
                  role="menuitem"
                  tabIndex={0}
                >
                  <span>SM Peer Directory</span>
                  <FontAwesomeIcon icon={faExternalLinkAlt as IconProp} />
                </a>
              </div>
            </div>
          </div>
        )
      case "ism-home":
        return (
          <div className="hero-menu-desktop ism" role="menubar">
            <div className="submenu-item text-center">
              <Link
                to="/ism/impact-of-ism/about-ism"
                className="sm-link-header impact-nav-item"
                activeClassName="active"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                partiallyActive
                role="menuitem"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.impact-nav-item');
                    const subMenuItem = document.querySelector('.impact-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Impact of ISM&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link
                  to="/ism/impact-of-ism/about-ism"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  About ISM
                </Link>
                <Link
                  to="/ism/impact-of-ism/burden-ism"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Burden of ISM
                </Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/about-ayvakit/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                tabIndex={0}
                role="menuitem"
              >
                &nbsp;&nbsp;About AYVAKIT&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center" role="menu" hidden>
              <Link
                to="/ism/efficacy"
                className="sm-link-header efficacy efficacy-nav-item"
                activeClassName="active"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                partiallyActive
                role="menuitem"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.efficacy-nav-item');
                    const subMenuItem = document.querySelector('.efficacy-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Efficacy&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem">
                <Link
                  to="/ism/efficacy/pioneer-study-design"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  PIONEER Study Design
                </Link>
                <Link to="/ism/efficacy" 
                      activeClassName="active" 
                      className="efficacy-subpage"
                      role="menuitem"
                      tabIndex={0}
                      data-gtm-event-action="Click"
                      data-gtm-event-category="Subpage Link"
                      data-gtm-event-label="Efficacy Subpage">
                  Efficacy
                </Link>
              </div>
            </div>
            <br className="submenu-br" />
            <div className="submenu-item text-center">
              <Link
                to="/ism/safety/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                tabIndex={0}
                role="menuitem"
              >
                &nbsp;&nbsp;Safety&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/dosing/"
                className="sm-link-header"
                activeClassName="active"
                partiallyActive
                tabIndex={0}
                role="menuitem"
              >
                &nbsp;&nbsp;Dosing&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/patient-perspectives/stories"
                className="sm-link-header patient-profiles-nav-item"
                activeClassName="active"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                partiallyActive
                role="menuitem"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.patient-profiles-nav-item');
                    const subMenuItem = document.querySelector('.patient-profiles-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Patient Perspectives&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu" hidden>
                <Link
                  to="/ism/patient-perspectives/stories"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Patient Stories
                </Link>
                <Link
                  to="/ism/patient-perspectives/profiles"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Patient Profiles
                </Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/ism/resources/access-support"
                className="sm-link-header resource-nav-item"
                activeClassName="active"
                aria-haspopup="true"
                aria-expanded="false"
                tabIndex={0}
                role="menuitem"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const parentSubMenu = document.querySelector('.resource-nav-item');
                    const subMenuItem = document.querySelector('.resource-nav-item + .sm-subitem');
                    if (subMenuItem) {
                      subMenuItem.classList.toggle('active');
                      if (subMenuItem.classList.contains('active')) {
                        parentSubMenu?.setAttribute('aria-expanded', 'true');
                      } else {
                        parentSubMenu?.setAttribute('aria-expanded', 'false');
                      }
                    }
                }}}
              >
                &nbsp;&nbsp;Resources&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem" role="menu">
                <Link
                  to="/ism/resources/access-support"
                  activeClassName="sm-active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Access and Support
                </Link>
                <Link
                  to="/ism/resources/practice-resources"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Practice Resources
                </Link>
                <Link
                  to="/ism/resources/patient-resources"
                  activeClassName="active"
                  role="menuitem"
                  tabIndex={0}
                >
                  Patient Resources
                </Link>
                <Link to="/ism/resources/faqs" activeClassName="sm-active" role="menuitem" tabIndex={0}>
                  FAQs
                </Link>
                <Link to="/ism/connect-with-us" activeClassName="active" role="menuitem" tabIndex={0}>
                  Connect with Us
                </Link>
                <a
                  href="https://www.smdirectory.com/"
                  target="_blank"
                  className="sm-peer-directory-nav-item"
                  rel="noopener"
                  role="menuitem"
                  tabIndex={0}
                >
                  <span>SM Peer Directory</span>
                  <FontAwesomeIcon icon={faExternalLinkAlt as IconProp} />
                </a>
              </div>
            </div>
          </div>
        )
      case "advsm":
        return (
          <div className="hero-menu-desktop advsm">
            <div className="submenu-item text-center">
              <Link
                to="/advsm/efficacy-data/"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Efficacy Data&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem">
                <Link to="/advsm/efficacy-data/#trial">
                  Clinical Trial Design
                </Link>
                <Link to="/advsm/efficacy-data/#response">
                  Overall Response
                  <br />
                  Rate
                </Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/advsm/safety-data/"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Safety Data&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/advsm/dosing/"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Dosing&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem">
                <Link to="/advsm/dosing/#starting-ayvakit">
                  Starting
                  <br />
                  Ayvakit
                </Link>
                <Link to="/advsm/dosing/#platelet-monitoring">
                  Platelet
                  <br />
                  Monitoring
                </Link>
                <Link to="/advsm/dosing/#dose-modifications">
                  Dose
                  <br />
                  Modifications
                </Link>
                <Link to="/advsm/dosing/#therapy-management">
                  Therapy
                  <br />
                  Management
                </Link>
              </div>
            </div>
            <br className="submenu-br" />
            <div className="submenu-item text-center">
              <Link
                to="/advsm/patient-profiles/"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Patient Profiles&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem">
                <Link to="/advsm/patient-profiles/#who-criteria">
                  WHO Criteria
                </Link>
                <Link to="/advsm/patient-profiles/#patient-profiles">
                  Patient Profiles
                </Link>
              </div>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/advsm/resources/"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Resources&nbsp;
                <span className="submenu-arrow">
                  <FontAwesomeIcon icon={faAngleDown as IconProp} />
                </span>
                &nbsp;&nbsp;
              </Link>
              <div className="sm-subitem">
                <Link to="/advsm/resources/#video-library">Video Library</Link>
                <Link to="/advsm/resources/#downloadable-materials">
                  Downloadable Materials
                </Link>
                <Link to="/advsm/resources/#your-blueprint-patient-support">
                  Your Blueprint Patient Support
                </Link>
                <Link to="/advsm/resources/#sign-up">
                  Contact a Representative
                </Link>
              </div>
            </div>
          </div>
        )
      case "gist":
        return (
          <div className="hero-menu-desktop gist">
            <div className="submenu-item text-center">
              <Link
                to="/gist-hcp/#about-ayvakit"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;About AYVAKIT&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/gist-hcp/#resources"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Resources&nbsp;&nbsp;
              </Link>
            </div>
            <div className="submenu-item text-center">
              <Link
                to="/gist-hcp/#contact-us"
                className="sm-link-header"
                activeClassName="active"
              >
                &nbsp;&nbsp;Contact Us&nbsp;&nbsp;
              </Link>
            </div>
            <br className="submenu-br" />
            <div className="submenu-item text-center">
              <Link
                to="https://yourblueprint.com/hcp"
                target="_blank"
                className="sm-link-header"
              >
                &nbsp;&nbsp;Support Program&nbsp;&nbsp;
              </Link>
            </div>
          </div>
        )
      default:
        return false
    }
  }

  const handleConditionTab = (
    event:
      | React.MouseEvent<HTMLParagraphElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement>
  ) => {
    event.preventDefault()
    const target = event.target as Element
    const tab = target.getAttribute("data-id")
    switch (tab) {
      case "ISM":
        window.location.href = "/ism/"
        break
      case "AdvSM":
        window.location.href = "/advsm/"
        break
      case "PDGFRA GIST":
        window.location.href = "/gist-hcp/"
        break
      default:
        console.log("Sorry, we are out of " + tab + ".")
        break
    }
  }

  useEffect(() => {
    //A useEffect that checks the page its on, if its a page that has a sm-subitem, it will add an sm-active class to the anchor tag
    const subItems =
        document.querySelectorAll<HTMLAnchorElement>(".sm-subitem a"),
      resourceNavItem = document.querySelector(".resources-nav-item"),
      efficacyNavItem = document.querySelector(".efficacy-nav-item"),
      impactNavItem = document.querySelector(".impact-nav-item"),
      patientProfilesNavItem = document.querySelector(".patient-profiles-nav-item")

    subItems.forEach(subItem => {
      if (window.location.href === subItem.href) {
        subItem.classList.add("sm-active")

        // Determine which parent menu to activate based on the URL
        const resourcePath =
          subItem.href.includes("/ism/resources/") ||
          subItem.href.includes("/ism/connect-with-us")
        const efficacyPath = subItem.href.includes("/ism/efficacy/")
        const impactPath = subItem.href.includes("/ism/impact-of-ism/burden-ism/")
        const patientProfilesPath = subItem.href.includes(
          "/ism/patient-perspectives/"
        )

        if (resourcePath && resourceNavItem) {
          resourceNavItem.classList.add("active")
        } else if (efficacyPath && efficacyNavItem) {
          efficacyNavItem.classList.add("active")
        } else if (impactPath && impactNavItem) {
          impactNavItem.classList.add("active")
        } else if (patientProfilesPath && patientProfilesNavItem) {
          patientProfilesNavItem.classList.add("active")
        }
      }
    })
  }, [])

  return (
    <nav className={"global-hero-container " + type}>
      {type !== "gateway" && (
        <>
          <div className="hero-menu-container">{placeSubNav(type)}</div>
          <div className={"condition-button-container " + type}>
            <ConditionButton />
          </div>
        </>
      )}
      {!hidesidebar && (
        <div className="condition-tab-container gw">
          <div className="ct-header">
            <p>SELECT A CONDITION</p>
          </div>
          <div className="condition-tab ct-ism bg-deep-turquoise white">
            <p
              className="ct-sm-header ct-ism-small-text"
              onClick={handleConditionTab}
              data-id="ISM"
            >
              <a href="/ism/" aria-label="Indolent systemic mastocytosis" data-id="ISM">
                ISM
              </a>
            </p>
            <p onClick={handleConditionTab} data-id="ISM">
              <a
                href="/ism/"
                aria-label="Indolent systemic mastocytosis"
                data-id="ISM"
                onClick={handleConditionTab}
              >
                Indolent systemic mastocytosis&nbsp;(ISM)
              </a>
            </p>
          </div>
          <div className="condition-tab ct-advsm bg-navy white">
            <p
              className="ct-sm-header ct-advsm-small-text"
              onClick={handleConditionTab}
              data-id="AdvSM"
            >
              <a href="/advsm/" aria-label="Advanced systemic mastocytosis">
                AdvSM
              </a>
            </p>
            <p onClick={handleConditionTab} data-id="AdvSM">
              <a
                href="/advsm/"
                aria-label="Advanced systemic mastocytosis"
                data-id="AdvSM"
                onClick={handleConditionTab}
              >
                Advanced systemic mastocytosis{" "}
                <span
                  className="nowrap"
                  data-id="AdvSM"
                  onClick={handleConditionTab}
                >
                  (AdvSM)
                </span>
              </a>
            </p>
          </div>
          <div className="condition-tab ct-gist bg-yellow navy last">
            <p
              className="ct-sm-header ct-gist-small-text"
              onClick={handleConditionTab}
              data-id="PDGFRA GIST"
            >
              <a
                href="/gist-hcp/"
                aria-label="Gastrointestinal stromal tumors with PDGFRA mutation"
                className="navy"
                data-id="PDGFRA GIST"
              >
                PDGFRA
                <br />
                GIST
              </a>
            </p>
            <p onClick={handleConditionTab} data-id="PDGFRA GIST">
              <a href="/gist-hcp/" aria-label="Gastrointestinal stromal tumors with PDGFRA mutation" data-id="PDGFRA GIST">
                Gastrointestinal stromal tumors with PDGFRA mutation{" "}
                <span className="nowrap">(PDGFRA GIST)</span>
              </a>
            </p>
          </div>
        </div>
      )}
      {placeHeroBlock(type)}
    </nav>
  )
}

export default GlobalHero
